import parse from "html-react-parser";
import "./about.scss";
import LoadingSpinner from "../components/loader/Loader";
import { useGetAboutQuery } from "../features/api/aboutApiSlice";

const AboutPage = () => {
  const { data: about, isLoading } = useGetAboutQuery(undefined, {
    pollingInterval: 15000,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });

  if (isLoading) return <LoadingSpinner />;
  return (
    <div className="main_wrapper">
      <div className="container">
        <header className="main-header">
          <h1>Welcome to eNotes Unlimited</h1>
        </header>
        {about?.map((about, index) => (
          <p key={index}>{parse(about?.description)}</p>
        ))}
      </div>
    </div>
  );
};

export default AboutPage;
